import { render, staticRenderFns } from "./PluginFeedbucket.vue?vue&type=template&id=87d5d654"
import script from "./PluginFeedbucket.vue?vue&type=script&lang=js"
export * from "./PluginFeedbucket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('87d5d654')) {
      api.createRecord('87d5d654', component.options)
    } else {
      api.reload('87d5d654', component.options)
    }
    module.hot.accept("./PluginFeedbucket.vue?vue&type=template&id=87d5d654", function () {
      api.rerender('87d5d654', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings/plugins/PluginFeedbucket.vue"
export default component.exports